<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>
<app-cc-form-dialog #ccAllocationFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    [submitButtonLabel]="'page.'+transPartKey+'.dialog.allocate'|translate"
                    [dialogClass]="'allocation-dialog'"
>
<!--  <span header-left>-->
<!--    <label [for]="'autoFillCustomerAcct_checkbox'" [class]="'header-checkbox'">-->
<!--      {{ 'page.' + this.transPartKey + '.form.label-autoFillCustomerAcct' | translate}}-->
<!--    </label>-->
<!--    <p-checkbox [binary]="true"-->
<!--                [class]="'header-checkbox'"-->
<!--                [(ngModel)]="autoFillCustomerAcct"-->
<!--                (onChange)="autoFillCBChanged($event.checked)"></p-checkbox>-->
<!--  </span>-->
  <app-clearing-selection-summary footer-left [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                  [owner]="owners?.length>1?formRecord?.owner:undefined"
                                  [showLoadingSpinner]="true"></app-clearing-selection-summary>
</app-cc-form-dialog>


